import classNames from "classnames";

export const DifficultyIndicator = ({ difficulty }: { difficulty: number }) => (
  <svg
    width={18}
    height={18}
    className={classNames(
      "inline",
      ["fill-green", "fill-yellow", "fill-accent"][difficulty - 1]
    )}
  >
    <circle cx={9} cy={9} r={9} fill="inherit" />
  </svg>
);
